export const ACCESS_TOKEN_LOCALSTORAGE_KEY = 'access_token';
export const CANDIDATES_LIST_GROUP_BY_LOCALSTORAGE_KEY =
  'candidate_list_group_by';
export const AVAILABLE_CANDIDATES_GROUP_BY_LOCALSTORAGE_KEY =
  'available_candidates_group_by';

export const ANALYTICS_ID_LOCALSTORAGE_KEY = 'analyticsId';
